import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CONFIG } from '../config/app-config';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class OrderService {

  constructor( private http: HttpClient ) { }

  getOrdersList(data: any) {
  	return this.http.post<any>(CONFIG.getAllOrderListURL, data)
    .pipe(map(response => {
        return response;
    }));
  }

  getOrderById(id: number) {
    return this.http.get<any>(CONFIG.getOrderByIdURL + id)
    .pipe(map(data => {
        return data;
      }));
  }

  changeOrderStatusDetailById(id: number) {
    return this.http.post<any>(CONFIG.changeOrderStatusDetailByIdURL + id, {})
    .pipe(map(data => {
        return data;
      }));
  }

  getOrdersConnectionList(data: any) {
  	return this.http.post<any>(CONFIG.getOrderConnectionListURL, data)
    .pipe(map(response => {
        return response;
    }));
  }
  getExportList(data) {
  	return this.http.post<any>(CONFIG.exportOrderURL, data)
    .pipe(map(response => {
        return response;
    }));
  }

  changeOrderStatus(id, status) {
    return this.http.post<any>(CONFIG.changeOrderStatusURL + id, status)
    .pipe(map(response => {
        return response;
    }));
  }

  deleteOrder(id: any) {
    return this.http.delete<any>(CONFIG.deleteOrderUrl + id).pipe(
      map((response) => {
        return response;
      })
    );
  }

  uploadInvoice(id, invoice) {
    return this.http.post<any>(CONFIG.uploadInvoice + id, invoice)
    .pipe(map(response => {
        return response;
    }));
  }

  updateAgentAllocation(uuid: string, payload: any) {
  return this.http.post<any>(
    CONFIG.updateAgentAllocationURL + uuid,
    payload
  ).pipe(
    map(response => {
      return response;
    })
  );
}

}
